import { useEffect } from 'react';

// @TODO: For now we are reusing cookie.js methods as is.
// Consider `public/assets/js/analytics/cookie.js` deprecated (noted in file),
// and we should refactor all cookie logic to React idioms. Related Jiras:
// [redacted]#############################
// [redacted]#############################
import { setMarketingTrackingCookies } from 'public/assets/js/analytics/cookie';

function useCookies(): null {
  useEffect(() => {
    setMarketingTrackingCookies();
  }, []);
  return null;
}

export default useCookies;
